import React from "react";
import { useSelector } from "react-redux";

import { IgDialog, IgLoading } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { getDialog } from "@src/store/slices/global";

export const WaitForShopifyDialog = () => {
  const dialog = useSelector(getDialog("waitForShopify"));

  const handleClose = () => {};

  return (
    <IgDialog
      showCloseIcon={false}
      title={"Generating Payment Link"}
      rawContent={
        <Grid container item>
          <Grid item ml={"auto"} mr={"auto"}>
            <IgLoading />
          </Grid>
        </Grid>
      }
      handleClose={handleClose}
      dialogHeight={"170px"}
      // maxWidth={"lg"}
      // dialogContentWidth={"400px"}
      showDialog={dialog.isOpen}
      hideActions={true}
    />
  );
};
